/**
 * 发布公司
 */
export const MEMBER_FIELD = `{
    id: memberId,
    name: memberName
}`

/**
 * 品种
 */
export const KIND_FIELD = `{
    id: kindId,
    name: kindName,
    code: kindCode
  }`

/**
 * 竞价预告
 */
export const ANNOUNCEMENT_FIELD = `{
  id: announcementId,
  title: announcementTitle
}`

/**
 * 计价方式
 */
export const PRICING_METHOD_FIELD = `{
    id: pricingMethodId,
    name: pricingMethodName,
    calcStrategy,
    quantityUnit,
    priceUnit
  }`

/**
 * 拆分数量
 */
export const SPLIT_COUNT_FIELD = `{
    wholeSale, 
    splitCount
}`

/**
 * 服务费方式
 */
export const SERVICE_FEE_FIELD = `{serviceFeeMethod,serviceFeeValue}`

/**
 * 起拍价
 */
export const START_PRICE_FIELD = `{startPrice,allowStartPrice}`

/**
 * 存放地
 */
export const STORAGE_PLACE_FIELD = `{
        id: storagePlaceId,
        code: storagePlaceCode,
        name: storagePlaceName
  }`

/**
 * 限制IP
 */
export const LIMIT_IP_FIELD = 'limitIp'
